import { Component, Vue, PropSync, Emit } from 'vue-property-decorator';
import { LoggerService } from '@/utils/index';
import { DataSetField } from '@/models/dataset/DataSetField';
import { UserProfileStore } from '@/store/store.userProfile';
import { ConfigurationService } from '@/services';
import { ConfigurationField } from '@/models/configuration/Field';
import { Helpers } from '@/helpers/Helpers';
import FieldComponent, { IFieldEvent } from '@/components/edit/field/Field';

import Field from '@/components/edit/field/Field.vue';


@Component({
    components: {
        Field,
    },
})
export default class TableEditValueComponent extends Vue {
    public demoVar: boolean = true;
    @PropSync('field', { type: Object }) public syncedField!: DataSetField;
    @PropSync('unitField', { type: Object }) public syncedUnitField!: ConfigurationField;
    @PropSync('show', { type: Boolean }) public syncedShow!: boolean;
    @PropSync('showUnit', { type: Boolean, default: false }) public syncedShowUnit!: boolean;

    // tslint:disable-next-line: no-empty
    public mounted() {
        if (this.syncedShowUnit === true) {
            this.fetchUnitType();
        }
    }

    public updated() {
        if (this.syncedShowUnit === true) {
            this.fetchUnitType();
        }
    }

    @Emit('close')
    public emitClose(save: boolean): boolean {
        return save;
    }

    public onFieldEvent(event: IFieldEvent) {
        LoggerService.LogDebug('onFieldEvent: ', event);
    }

    public onClose(save: boolean) {
        if (save === true && this.syncedShowUnit === true) {
            const fieldRef = Helpers.getReference<FieldComponent>(this.$refs, 'unitTypeFieldRef');
            if (fieldRef && fieldRef.validateField(true) === false) {
                return;
            }
        }
        this.syncedShow = false;
        this.emitClose(save);
    }

    private fetchUnitType() {
        const unitFormat = ConfigurationService.GetUnitsConfiguration.sections.find((sec) => sec.identifier === this.syncedUnitField.unitIdentifier);
        if (unitFormat !== undefined && unitFormat.values !== undefined && UserProfileStore.userProfile !== undefined) {
            this.syncedUnitField.valueNumber = (unitFormat.values.find((v) => v.value === unitFormat.base) || unitFormat.values[0]).value as number;
        }
    }
}
